(function initAccordions() {
	var acc = Array.from(document.getElementsByClassName("accordion")).filter((accordion) => accordion.closest('.collapsible-content') == undefined && !accordion.classList.contains('product__accordion'));
	var i;

	for (i = 0; i < acc.length; i++) {
		acc[i].addEventListener("click", function() {
			/* Toggle between adding and removing the "active" class,
			to highlight the button that controls the panel */

			if (this.classList.contains('active')) {
				this.classList.remove("active");
			} else {
				this.classList.add("active");
			}

			/* Toggle between hiding and showing the active panel */
			var panel = this.nextElementSibling;
			if (panel.style.maxHeight) {
				panel.style.maxHeight = null;
			} else {
				panel.style.maxHeight = panel.scrollHeight + "px";
			}
		});
	};
})();
